import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';
import { getNextTenCalendarYears, getPreviousTenCalendarYears } from '../../../utils';
import DateRangePicker from '../DateRangePicker';

const minDate = getPreviousTenCalendarYears();
const maxDate = getNextTenCalendarYears();

export default class LicensesPaymentsReportFilter extends PureComponent {

    handleChangeDate = name => date => {
        const stateDate = date?.clone().utc(true).format();
        this.props.handleChangeDates(name, stateDate);
    };

    render() {
        const { startDate, endDate, loading, handleErrorDate, errors, t } = this.props;

        return (
            <DateRangePicker
                startName="startDate"
                endName="endDate"
                title="periodDate"
                minDate={minDate}
                maxDate={maxDate}
                value={{
                    startDate: startDate ? dayjs(startDate) : null,
                    endDate: endDate ? dayjs(endDate) : null
                }}
                handleChangeStartDate={this.handleChangeDate}
                handleChangeEndDate={this.handleChangeDate}
                handleError={handleErrorDate}
                errors={errors}
                disabled={loading}
                t={t}
            />
        );
    }
}

LicensesPaymentsReportFilter.propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    handleChangeDates: PropTypes.func.isRequired,
    handleErrorDate: PropTypes.func.isRequired,
    errors: PropTypes.object
};
